import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpParamsOptions, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { environment } from '@env/environment';

import { map, tap, switchMap } from 'rxjs/operators';

import { SortDirection } from '@angular/material/sort';

import { AuthQuery } from '@app/auth/auth.query';

/*
const HttpUploadOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
  }),
};
*/

export enum StatusTransfer {
  DRAFT = '0',
  TRANSFER = '1',
  UNGULTIG = '3',
}

/*
export interface IBaseRequest {
  api_key: string;
  phone_id: string;
  token: string;
  gemeinde_key: string;

  dienstnr_id: string;
  dienstnr_stvo: string;
  person: string;
}
*/

export interface TransferMandat {
  id: number;
  aktenzeichen: string;
  plate: string;
  kzland: string;
  kzbezirk: string;
  kznummer: string;
  street: string;
  streetnbr: string;
  hersteller: string;
  farbe: string;
  createdate: string;
  createtime: string;
  dienstnr_id: number;
  person: string;
  tatbestnr: string;
  konkretisierung: string;
  printed: number;
  printdate: string;
  printcount: number;
  mandat_id: number;
  transferred: number;
  transferdate: string;
  notes: string;
  info1: string;
  info2: string;
  info3: string;
  longitude: string;
  lattitude: string;
  fahrzeugart: number;
  zone: number;
  ticketnr: number;
  ticket_zeit: string;
  zusatz1: string;
  zusatz2: string;
  strafe: number;
  dienstnr_stvo: number;
  transfer_db: number;
  status_id: string;
  created: string;

  tatzeit: string;
  tat_datum: string;
  tat_zeit: string;
  tatzeit_bis_datum?: string;
  tatzeit_bis_uhrzeit?: string;

  exif: string;
  bom: number;  // 1 = BOM, 0 = Anzeige

  anpr_json?: string; // full plate recognizer response
  anpr_selected_index?: number; // chosen result index inside results[]

  // additional params for checking
  errorId?: number;
  errorMessage?: string; // Dynamic error message
}

export interface TransferMandatSingle {
  data: TransferMandat;
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

export interface TransferMandatTable {
  data: TransferMandat[];
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

export interface PlateRecon {
  id: number;
  aktenzeichen: string;
  land: string;
  bezirk: string;
  kennzeichen: string;
  plate: string;
  farbe: string;
  hersteller: string;
  notes: string;
  anpr_json?: string;
  anpr_selected_index?: number;
  entity?: 'transfer' | 'mandate';
}

/**
 * Payload for creating a brand new transfer item (Anzeige/BOM) from the web wizard.
 * Mirrors the minimal "draft" set the mobile app sends; details are completed later
 * in the transfer edit panel.
 */
export interface NewTransferItem {
  bom: number; // 0 = Anzeige, 1 = BOM
  aktenzeichen: string; // reserved via /nxakt before image upload
  kzland: string;
  kzbezirk: string;
  kznummer: string;
  street: string;
  streetnbr: string;
  hersteller: string;
  farbe: string;
  tat_datum: string; // DD.MM.YYYY
  tat_zeit: string; // HH:MM
  tatzeit_bis_datum?: string; // BOM only
  tatzeit_bis_uhrzeit?: string; // BOM only
}

/**
 * Default values applied to every bulk-scan import (clone of the legacy C#
 * "Barcode" settings tab). The scanned barcode becomes the aktenzeichen; these
 * defaults fill the remaining minimal fields so the record can be completed
 * later before the VSTV export.
 */
export interface BulkDefaults {
  strafe: number;
  kzland: string;
  kzbezirk: string;
  zone: number;
  fahrzeugart: number;
  bearbeiter: string;
}

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Origin': '*',
  }),
};

//
// --------------------------------------------------------------
//

@Injectable({
  providedIn: 'root',
})
export class TransferMandatService {
  errorMsg: string = '';

  constructor(private httpClient: HttpClient, private authQuery: AuthQuery) {}

  /**
   * GET ALL
   *
   * @return response()
   */

  public getTransferMandate(
    pageNumber: Number,
    pageSize: Number,
    sort: string,
    order: SortDirection,
    searchTerm: string,
    filtersArgs: string
  ): Observable<TransferMandatTable> {
    const apiUrl = `${environment.serverUrl}/transfer`;
    // '?page=${pageNumber}&per_page=${pageSize}&sort=${sort}&sorder=${order}`

    return this.httpClient.get<TransferMandatTable>(apiUrl, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Origin': '*',
      }),
      params: new HttpParams()
        .set('page', '' + pageNumber)
        .set('per_page', '' + pageSize)
        .set('sort', sort)
        .set('sorder', order)
        .set('sterm', searchTerm)
        .set('filters', filtersArgs)
        .set('webapp', 1),
    });

    /*
    .pipe(
      map((response: VisitorTable) => {
        //debugger;
        return response.data.map((item: Visitor) => ({
          ...item,
        }));
      }),
      tap((response: any) => {
        console.log('mrio');
        console.log(response);
        return <Visitor[]>response;
      }),
      catchError((error) => {
        let errorMsg: string = '';
        if (error.error instanceof ErrorEvent) {
          errorMsg = `Error: ${error.error.message}`;
        } else {
          errorMsg = this.getServerErrorMessage(error);
        }

        return throwError(errorMsg);
      })
    );
    */
  }

  /**
   * GET / FIND BY ID
   *
   * @return response()
   */
  getTransferMandatById(id: number): Observable<TransferMandatSingle> {
    const apiUrl = `${environment.serverUrl}/transfer/` + id;

    return this.httpClient
      .get<TransferMandatSingle>(apiUrl, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          // 'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Origin': '*',
        }),
        params: new HttpParams().set('id', '' + id),
      })
      .pipe(
        map((response: TransferMandatSingle) => {
          return {
            ...response,
          };
        })
      );

    /*
    return this.httpClient.get<Visitor[]>(environment.serverUrl + '/visitor/' + id, httpOptions).pipe(
      tap((resp) => {
        //this.repo.setQuizes( resp || []);
        return resp;
      }),
      catchError((error) => {
        let errorMsg: string = '';
        if (error.error instanceof ErrorEvent) {
          this.errorMsg = `Error: ${error.error.message}`;
        } else {
          this.errorMsg = this.getServerErrorMessage(error);
        }

        return throwError(errorMsg);
      })
    );
    */
  }

  /**
   * GET / FIND BY FILTER
   *
   * @return response()
   */
  getTransferMandatByParams(data: any): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    //const data: any = { this: 'thisThing', that: 'thatThing', other: 'otherThing'};

    const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;

    const options = { params: new HttpParams(httpParams), headers: headers };

    return this.httpClient.get<TransferMandat[]>(environment.serverUrl + '/transfer/', options).pipe(
      tap((resp) => {
        //this.repo.setQuizes( resp || []);
        return resp;
      }),
      catchError((error) => {
        let errorMsg: string = '';
        if (error.error instanceof ErrorEvent) {
          this.errorMsg = `Error: ${error.error.message}`;
        } else {
          this.errorMsg = this.getServerErrorMessage(error);
        }

        return throwError(errorMsg);
      })
    );
  }

  /**
   * clone the TRANSFER into the MANDATE >>> damit wird es zu einem AKTIVEN Strafmandat (Status-erfasst)
   *          oder auch für die polizeit TEILERFASST !!!!!!! BUG BUG BUG
   *
   * @return response()
   */
  doTransfer2Mandate(postData: any): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    //const data: any = { this: 'thisThing', that: 'thatThing', other: 'otherThing'};

    return this.httpClient
      .post<any>(environment.serverUrl + '/transfer2mandate/', JSON.stringify(postData), httpOptions)
      .pipe(
        map((response) => {
          return {
            ...response.data,
          };
        }),
        tap((response: any) => {
          console.log(response);
          //this.repo.addQuiz(response);
        }),
        catchError((error) => {
          let errorMsg: string = '';
          if (error.error instanceof ErrorEvent) {
            this.errorMsg = `Error: ${error.error.message}`;
          } else {
            this.errorMsg = this.getServerErrorMessage(error);
          }

          return throwError(errorMsg);
        })
      );
  }

  bulkSetTransferStatus(payload: { selectedIds: number[]; statusId: number }): Observable<any> {
    return this.httpClient
      .post<any>(environment.serverUrl + '/bulk-status-transfer', JSON.stringify(payload), httpOptions)
      .pipe(
        map((response) => response),
        catchError((error) => {
          let errorMsg: string = '';
          if (error.error instanceof ErrorEvent) {
            this.errorMsg = `Error: ${error.error.message}`;
          } else {
            this.errorMsg = this.getServerErrorMessage(error);
          }
          return throwError(errorMsg);
        })
      );
  }

  /**
   * CREATE
   *
   * @return response()

  createVisitor(post: any): Observable<any> {
    return this.httpClient.post<any>(environment.serverUrl + '/transfer/', JSON.stringify(post), httpOptions).pipe(
      map((response) => {
        return {
          ...response.data,
          id: response.data.quuid,
          quizdata: '',
        };

      }),
      tap((response: any) => {
        console.log(response);
        //this.repo.addQuiz(response);
      }),
      catchError((error) => {
        let errorMsg: string = '';
        if (error.error instanceof ErrorEvent) {
          this.errorMsg = `Error: ${error.error.message}`;
        } else {
          this.errorMsg = this.getServerErrorMessage(error);
        }

        return throwError(errorMsg);
      })
    );
  }
  */

  /**
   * UPDATE
   *
   * @return response()
   */
  updateTransfer(transfer: TransferMandat): Observable<any> {
    // get the base request data
    var requestAuth = {
      apikey: '' + environment.api_key,
      phone_id: this.authQuery.getValue().phone_id,
      token: this.authQuery.getValue().access_token,
      akey: '' + environment.api_key,

      did: this.authQuery.getValue().dienstnr,
      didstvo: this.authQuery.getValue().dienstnr_stvo,
      didname: this.authQuery.getValue().dienstname,
    };

    // get the data for the item to save
    var id = transfer.id;
    var transfer_json = JSON.stringify(transfer);
    const data = {
      ...requestAuth,
      id: id,
      aktenzeichen: transfer.aktenzeichen,
      mandat: transfer_json,
    };

    return this.httpClient.post<any>(environment.serverUrl + '/tupdate', JSON.stringify(data), httpOptions).pipe(
      map((response) => {
        console.log('map');
        return {
          ...response.mandat,
        };
      }),
      tap((response: any) => {
        console.log('tAP');
        console.log(response);
        //this.repo.updateQuiz(response);
      }),
      catchError((error) => {
        let errorMsg: string = '';
        if (error.error instanceof ErrorEvent) {
          this.errorMsg = `Error: ${error.error.message}`;
        } else {
          this.errorMsg = this.getServerErrorMessage(error);
        }

        return throwError(errorMsg);
      })
    );
  }

  /**
   * FINALIZE
   *
   * @return response()
   */
  finalizeTransfer(transfer: TransferMandat): Observable<any> {
    // get the base request data
    var requestAuth = {
      apikey: '' + environment.api_key,
      phone_id: this.authQuery.getValue().phone_id,
      token: this.authQuery.getValue().access_token,
      akey: '' + environment.api_key,

      did: this.authQuery.getValue().dienstnr,
      didstvo: this.authQuery.getValue().dienstnr_stvo,
      didname: this.authQuery.getValue().dienstname,
    };

    // get the data for the item to save
    var id = transfer.id;
    var transfer_json = JSON.stringify(transfer);
    const data = {
      ...requestAuth,
      id: id,
      aktenzeichen: transfer.aktenzeichen,
    };

    console.log('sylvia war da');
    console.log(data);

    return this.httpClient.post<any>(environment.serverUrl + '/mandatefin', JSON.stringify(data), httpOptions).pipe(
      map((response) => {
        console.log('map');
        return {
          ...response.mandat,
        };
      }),
      tap((response: any) => {
        console.log('tAP');
        console.log(response);
        //this.repo.updateQuiz(response);
      }),
      catchError((error) => {
        let errorMsg: string = '';
        if (error.error instanceof ErrorEvent) {
          this.errorMsg = `Error: ${error.error.message}`;
        } else {
          this.errorMsg = this.getServerErrorMessage(error);
        }

        return throwError(errorMsg);
      })
    );
  }

  /**
   * CHECK
   *
   * @return response()
   */
  checkTransfer(transfer: TransferMandat): Observable<any> {
    // get the base request data
    var requestAuth = {
      apikey: '' + environment.api_key,
      phone_id: '' + this.authQuery.getValue().phone_id,
      token: '' + this.authQuery.getValue().access_token,
      akey: '' + environment.api_key,

      did: '' + this.authQuery.getValue().dienstnr,
      didstvo: '' + this.authQuery.getValue().dienstnr_stvo,
      didname: '' + this.authQuery.getValue().dienstname,
    };

    // get the data for the item to save
    var id = transfer.id;
    var transfer_json = JSON.stringify(transfer);
    const data = {
      ...requestAuth,
      id: id,
      aktenzeichen: transfer.aktenzeichen,
    };

    console.log('sylvia war da');
    console.log(data);

    return this.httpClient.post<any>(environment.serverUrl + '/transfercheck', JSON.stringify(data), httpOptions).pipe(
      map((response) => {
        console.log('map');
        return {
          positiv: response.result,
          ...response,
        };
      }),
      tap((response: any) => {
        console.log('tAP');
        console.log(response);
        //this.repo.updateQuiz(response);
      }),
      catchError((error) => {
        let errorMsg: string = '';
        if (error.error instanceof ErrorEvent) {
          this.errorMsg = `Error: ${error.error.message}`;
        } else {
          this.errorMsg = this.getServerErrorMessage(error);
        }

        return throwError(errorMsg);
      })
    );
  }

  /**
   * UPDATE
   *
   * @return response()
   */
  changeStatus(transfer: TransferMandat, newStatusID: string): Observable<any> {
    // get the base request data
    var requestAuth = {
      apikey: '' + environment.api_key,
      phone_id: this.authQuery.getValue().phone_id,
      token: this.authQuery.getValue().access_token,
      akey: '' + environment.api_key,

      did: this.authQuery.getValue().dienstnr,
      didstvo: this.authQuery.getValue().dienstnr_stvo,
      didname: this.authQuery.getValue().dienstname,
    };

    // get the data for the item
    var id = transfer.id;
    //var transfer_json = JSON.stringify(transfer);
    const data = {
      ...requestAuth,
      id: id,
      aktenzeichen: transfer.aktenzeichen,
      ostatusid: transfer.status_id,
      nstatusid: newStatusID,
    };

    console.log(data);

    return this.httpClient.post<any>(environment.serverUrl + '/cstatus', JSON.stringify(data), httpOptions).pipe(
      map((response) => {
        console.log('map');
        return {
          ...response.mandat,
        };
      }),
      tap((response: any) => {
        console.log('tAP');
        console.log(response);
        //this.repo.updateQuiz(response);
      }),
      catchError((error) => {
        let errorMsg: string = '';
        if (error.error instanceof ErrorEvent) {
          this.errorMsg = `Error: ${error.error.message}`;
        } else {
          this.errorMsg = this.getServerErrorMessage(error);
        }

        return throwError(errorMsg);
      })
    );
  }

  /**
   * CHANGE TYPE (Storno & Neu)
   *
   * Storniert den originalen Transfer (status ungültig) und legt einen neuen Transfer
   * mit geändertem Typ (Anzeige <-> BOM), neuer Aktenzahl und kopierten Bildern an.
   *
   * @return response() -> { result, newId, newAktenzeichen, oldId, oldAktenzeichen }
   */
  changeTransferType(transferId: number, newBom: number, note: string = ''): Observable<any> {
    // get the base request data
    var requestAuth = {
      apikey: '' + environment.api_key,
      phone_id: this.authQuery.getValue().phone_id,
      token: this.authQuery.getValue().access_token,
      akey: '' + environment.api_key,

      did: this.authQuery.getValue().dienstnr,
      didstvo: this.authQuery.getValue().dienstnr_stvo,
      didname: this.authQuery.getValue().dienstname,
    };

    const data = {
      ...requestAuth,
      id: transferId,
      newBom: newBom,
      note: note,
    };

    return this.httpClient
      .post<any>(environment.serverUrl + '/transfer-change-type', JSON.stringify(data), httpOptions)
      .pipe(
        map((response) => response),
        catchError((error) => {
          let errorMsg: string = '';
          if (error.error instanceof ErrorEvent) {
            this.errorMsg = `Error: ${error.error.message}`;
          } else {
            this.errorMsg = this.getServerErrorMessage(error);
          }
          return throwError(errorMsg);
        })
      );
  }

  /**
   * DELETE --- > in unserem fall ist es kein delete -> sondern ein status-change !! auf ungültig
   *
   * @return response()

  deleteVisitor(id: string) {
    return this.httpClient.delete(environment.serverUrl + '/visitor/' + id, httpOptions).pipe(
      tap((value) => {
        //this.repo.removeQuiz(id);
      }),
      catchError((error) => {
        let errorMsg: string = '';
        if (error.error instanceof ErrorEvent) {
          this.errorMsg = `Error: ${error.error.message}`;
        } else {
          this.errorMsg = this.getServerErrorMessage(error);
        }

        return throwError(errorMsg);
      })
    );
  }
  */

  /**
   * SAVE PLATE RECOGNITION
   *
   * @return response()
   */
  savePlateRecognition(plateRecon: PlateRecon): Observable<any> {
    // get the base request data
    var requestAuth = {
      apikey: '' + environment.api_key,
      phone_id: this.authQuery.getValue().phone_id,
      token: this.authQuery.getValue().access_token,
      akey: '' + environment.api_key,
      sec_number: '' + environment.api_key,

      did: this.authQuery.getValue().dienstnr,
      didstvo: this.authQuery.getValue().dienstnr_stvo,
      didname: this.authQuery.getValue().dienstname,
    };

    // get the data for the item to save
    const data = {
      ...requestAuth,
      ...plateRecon,
    };

    console.log('sylvia war da');
    console.log(data);

    return this.httpClient.post<any>(environment.serverUrl + '/mandatanpr', JSON.stringify(data), httpOptions).pipe(
      map((response) => {
        console.log('map');
        return {
          ...response.mandat,
        };
      }),
      tap((response: any) => {
        console.log('tAP');
        console.log(response);
        //this.repo.updateQuiz(response);
      }),
      catchError((error) => {
        let errorMsg: string = '';
        if (error.error instanceof ErrorEvent) {
          this.errorMsg = `Error: ${error.error.message}`;
        } else {
          this.errorMsg = this.getServerErrorMessage(error);
        }

        return throwError(errorMsg);
      })
    );
  }

  /**
   * NEXT AKTENZEICHEN
   *
   * Reserve/preview the next case number for the given type so images can be
   * attached (via FilePond) before the record itself is created.
   *
   * @return response() -> { result, next }
   */
  getNextAktenzeichen(bom: boolean): Observable<any> {
    const apiUrl = `${environment.serverUrl}/nxakt`;

    return this.httpClient
      .get<any>(apiUrl, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        }),
        params: new HttpParams()
          .set('apikey', '' + environment.api_key)
          .set('phone_id', '' + this.authQuery.getValue().phone_id)
          .set('token', '' + this.authQuery.getValue().access_token)
          .set('akey', '' + environment.api_key)
          .set('did', '' + this.authQuery.getValue().dienstnr)
          .set('didstvo', '' + this.authQuery.getValue().dienstnr_stvo)
          .set('didname', '' + this.authQuery.getValue().dienstname)
          .set('bom', bom ? 'true' : 'false'),
      })
      .pipe(
        catchError((error) => {
          let errorMsg: string = '';
          if (error.error instanceof ErrorEvent) {
            this.errorMsg = `Error: ${error.error.message}`;
          } else {
            this.errorMsg = this.getServerErrorMessage(error);
          }
          return throwError(errorMsg);
        })
      );
  }

  /**
   * CREATE NEW ITEM (Anzeige / BOM)
   *
   * Creates a new draft transfer using the same endpoint the mobile app uses
   * (POST /cmandat). The reserved aktenzeichen is sent explicitly so it lines up
   * with images already uploaded in the wizard. As /cmandat does not persist the
   * Tatzeit-"von" fields, a best-effort follow-up /tupdate stores them once the
   * new record id has been resolved by its (unique) aktenzeichen.
   *
   * @return response() -> { result, aktenzeichen, id? }
   */
  createNewItem(item: NewTransferItem): Observable<any> {
    const auth = {
      apikey: '' + environment.api_key,
      phone_id: this.authQuery.getValue().phone_id,
      token: this.authQuery.getValue().access_token,
      akey: '' + environment.api_key,

      did: this.authQuery.getValue().dienstnr,
      didstvo: this.authQuery.getValue().dienstnr_stvo,
      didname: this.authQuery.getValue().dienstname,
    };

    const dienstnr = this.authQuery.getValue().dienstnr;
    const dienstnr_stvo = this.authQuery.getValue().dienstnr_stvo;
    const person = this.authQuery.getValue().dienstname;

    const plate = [item.kzland, item.kzbezirk, item.kznummer]
      .map((p) => ('' + (p ?? '')).trim())
      .filter((p) => p !== '')
      .join(' ');

    // Full mandate object: createTransfer (PHP) reads these keys directly.
    const mandate: any = {
      bom: item.bom,
      aktenzeichen: item.aktenzeichen || '',
      plate: plate,
      kzland: item.kzland || '',
      kzbezirk: item.kzbezirk || '',
      kznummer: item.kznummer || '',
      street: item.street || '',
      streetnbr: item.streetnbr || '',
      hersteller: item.hersteller || '',
      farbe: item.farbe || '',
      createdate: item.tat_datum || '',
      createtime: item.tat_zeit || '',
      dienstnr_id: dienstnr,
      dienstnr_stvo: dienstnr_stvo,
      person: person,
      tatbestnr: '',
      konkretisierung: '',
      zusatz1: '',
      zusatz2: '',
      strafe: 0,
      printed: 0,
      printdate: '',
      printcount: 0,
      mandat_id: 0,
      transferred: 0,
      transferdate: '',
      lattitude: '0',
      longitude: '0',
      notes: '',
      fahrzeugart: 0,
      zone: 0,
      ticketnr: 0,
      ticket_zeit: '',
      deviceid: 'webapp',
    };
    if (item.bom === 1) {
      mandate.tatzeit_bis_datum = item.tatzeit_bis_datum || '';
      mandate.tatzeit_bis_uhrzeit = item.tatzeit_bis_uhrzeit || '';
    }

    const createPayload = {
      ...auth,
      content: JSON.stringify({ mandate: [JSON.stringify(mandate)], images: [] }),
    };

    return this.httpClient
      .post<any>(environment.serverUrl + '/cmandat', JSON.stringify(createPayload), httpOptions)
      .pipe(
        switchMap((createRes) => {
          // best effort: resolve the new id and persist the Tatzeit-"von" fields
          return this.findTransferIdByAktenzeichen(item.aktenzeichen).pipe(
            switchMap((foundId) => {
              if (!foundId) {
                return of({ result: 1, aktenzeichen: item.aktenzeichen, ...createRes });
              }

              const formMandat = {
                id: foundId,
                aktenzeichen: item.aktenzeichen,
                plate: plate,
                land: item.kzland || '',
                bezirk: item.kzbezirk || '',
                nummer: item.kznummer || '',
                strasse: item.street || '',
                hausnummer: item.streetnbr || '',
                hersteller: item.hersteller || '',
                farbe: item.farbe || '',
                fahrzeugart: '',
                tatbestandNr: '',
                konkretisierung: '',
                strafe: '0',
                anmerkungen: '',
                probekennzeichen: '',
                internal_notes: '',
                tatzeit: item.tat_zeit || '',
                tat_zeit: item.tat_zeit || '',
                tat_datum: item.tat_datum || '',
                tatzeit_bis_datum: item.bom === 1 ? item.tatzeit_bis_datum || '' : '',
                tatzeit_bis_uhrzeit: item.bom === 1 ? item.tatzeit_bis_uhrzeit || '' : '',
                bom: item.bom,
              };

              const updatePayload = {
                ...auth,
                id: foundId,
                aktenzeichen: item.aktenzeichen,
                mandat: JSON.stringify(formMandat),
              };

              return this.httpClient
                .post<any>(environment.serverUrl + '/tupdate', JSON.stringify(updatePayload), httpOptions)
                .pipe(
                  map((updRes) => ({ result: 1, aktenzeichen: item.aktenzeichen, id: foundId, ...updRes })),
                  catchError(() => of({ result: 1, aktenzeichen: item.aktenzeichen, id: foundId }))
                );
            }),
            catchError(() => of({ result: 1, aktenzeichen: item.aktenzeichen }))
          );
        }),
        catchError((error) => {
          let errorMsg: string = '';
          if (error.error instanceof ErrorEvent) {
            this.errorMsg = `Error: ${error.error.message}`;
          } else {
            this.errorMsg = this.getServerErrorMessage(error);
          }
          return throwError(errorMsg);
        })
      );
  }

  /**
   * BULK SCAN IMPORT (clone of legacy C# frm_BulkEdit "Liste erfassen")
   *
   * The scanned barcode IS the aktenzeichen. Creates a minimal draft transfer
   * (POST /cmandat) stamped with the logged-in officer + the configured bulk
   * defaults (Strafe/Land/Bezirk/Zone/Fahrzeugart/Bearbeiter). The rest of the
   * data is completed later in the transfer edit panel before VSTV export.
   *
   * @return response() -> { result, aktenzeichen, id? }
   */
  createBulkScanItem(aktenzeichen: string, bom: number, defaults: BulkDefaults): Observable<any> {
    const auth = {
      apikey: '' + environment.api_key,
      phone_id: this.authQuery.getValue().phone_id,
      token: this.authQuery.getValue().access_token,
      akey: '' + environment.api_key,

      did: this.authQuery.getValue().dienstnr,
      didstvo: this.authQuery.getValue().dienstnr_stvo,
      didname: this.authQuery.getValue().dienstname,
    };

    const dienstnr = this.authQuery.getValue().dienstnr;
    const dienstnr_stvo = this.authQuery.getValue().dienstnr_stvo;
    const person = (defaults.bearbeiter && defaults.bearbeiter.trim() !== ''
      ? defaults.bearbeiter
      : this.authQuery.getValue().dienstname) || '';

    const now = new Date();
    const pad = (n: number) => ('' + n).padStart(2, '0');
    const createdate = `${pad(now.getDate())}.${pad(now.getMonth() + 1)}.${now.getFullYear()}`;
    const createtime = `${pad(now.getHours())}:${pad(now.getMinutes())}`;

    const mandate: any = {
      bom: bom,
      aktenzeichen: '' + aktenzeichen,
      plate: '',
      kzland: defaults.kzland || '',
      kzbezirk: defaults.kzbezirk || '',
      kznummer: '',
      street: '',
      streetnbr: '',
      hersteller: '',
      farbe: '',
      createdate: createdate,
      createtime: createtime,
      dienstnr_id: dienstnr,
      dienstnr_stvo: dienstnr_stvo,
      person: person,
      tatbestnr: '',
      konkretisierung: '',
      zusatz1: '',
      zusatz2: '',
      strafe: defaults.strafe || 0,
      printed: 0,
      printdate: '',
      printcount: 0,
      mandat_id: 0,
      transferred: 0,
      transferdate: '',
      lattitude: '0',
      longitude: '0',
      notes: '',
      fahrzeugart: defaults.fahrzeugart || 0,
      zone: defaults.zone || 0,
      ticketnr: 0,
      ticket_zeit: '',
      deviceid: 'webapp-bulk',
    };

    const createPayload = {
      ...auth,
      content: JSON.stringify({ mandate: [JSON.stringify(mandate)], images: [] }),
    };

    return this.httpClient
      .post<any>(environment.serverUrl + '/cmandat', JSON.stringify(createPayload), httpOptions)
      .pipe(
        switchMap((createRes) =>
          this.findTransferIdByAktenzeichen('' + aktenzeichen).pipe(
            map((foundId) => ({ result: 1, aktenzeichen: '' + aktenzeichen, id: foundId, ...createRes })),
            catchError(() => of({ result: 1, aktenzeichen: '' + aktenzeichen }))
          )
        ),
        catchError((error) => {
          let errorMsg: string = '';
          if (error.error instanceof ErrorEvent) {
            this.errorMsg = `Error: ${error.error.message}`;
          } else {
            this.errorMsg = this.getServerErrorMessage(error);
          }
          return throwError(errorMsg);
        })
      );
  }

  /**
   * Check whether a transfer with the given aktenzeichen already exists
   * (used by the bulk-import scan to reject duplicates, mirroring the C# flow).
   */
  public checkAktenzeichenExists(aktenzeichen: string): Observable<boolean> {
    return this.findTransferIdByAktenzeichen('' + aktenzeichen).pipe(map((id) => id !== null));
  }

  /**
   * Resolve the id of a freshly created transfer by its (unique) aktenzeichen.
   * Searches across all statuses; returns the highest matching id or null.
   */
  private findTransferIdByAktenzeichen(aktenzeichen: string): Observable<number | null> {
    if (!aktenzeichen) {
      return of(null);
    }
    const filters = JSON.stringify([['Status', 'Alle']]);
    return this.getTransferMandate(1, 50, 'id', 'desc', '' + aktenzeichen, filters).pipe(
      map((table) => {
        const rows = (table?.data || []).filter((r) => '' + r.aktenzeichen === '' + aktenzeichen);
        if (!rows.length) {
          return null;
        }
        return rows.reduce((maxId, r) => (r.id > maxId ? r.id : maxId), rows[0].id);
      }),
      catchError(() => of(null))
    );
  }

  /**
   * Write code on Method
   *
   * @return response()
   */
  private getServerErrorMessage(error: HttpErrorResponse) {
    console.log('custom service error handler');

    switch (error.status) {
      case 0: {
        // A client-side or network error occurred. Handle it accordingly.
        //console.error('An error occurred:', error.error);
        return `An error occurred: ${error.error}`;
      }
      case 404: {
        return `Not Found: ${error.message}`;
      }
      case 403: {
        return `Access Denied: ${error.message}`;
      }
      case 500: {
        return `Internal Server Error: ${error.message}`;
      }
      default: {
        return `Unknown Server Error: ${error.error}`;
      }

      // Return an observable with a user-facing error message.
      //return throwError(() => new Error('Something bad happened; please try again later.'));
    }
  }
}
